import React, { useEffect, useState, useContext } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import Pagination from "../../Components/Pagination";

function ListReports(props) {
  const apiToken = useContext(TokenContext);
  const [reportsList, setReportsList] = useState([]);
  const [reportsListTemp, setReportsListTemp] = useState();
  const [isOpen, toggleModal] = useState(false);
  const [removableReport, setRemovableReport] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false);
    Repo.getReportsList(apiToken)
      .then((response) => {
        setReportsListTemp(response.data);
        setLoading(true);
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });
  }, []);

  const openReport = (reportId) => {
    window.location.href =
      props.subfolder + "/report/dettaglio_report?report=" + reportId;
  };

  const editReport = (reportId) => {
    window.location.href =
      props.subfolder + "/report/modifica_report?report=" + reportId;
  };

  const removeReportAPI = () => {
    Repo.postDeleteReport(apiToken, removableReport)
      .then((response) => {
        if (response.status == 200 || response.status == 204) {
          setRemovableReport("");
          window.location.href = props.subfolder + "/report";
        }
      })
      .catch((error) => {
        console.log(error);
        setRemovableReport("");
      });
  };

  return (
    <>
      <div>
        <h1>Report</h1>
        <div className="row">
          <div className="clearfix col-8 py-lg-2">
            <p>
              Elenco dei report configurati. Seleziona un report per eseguirlo e
              visualizzare i risultati, oppure creane uno nuovo indicando titolo,
              descrizione e query.
            </p>
          </div>

          <div className="col-4 clearfix">
            <button
              type="button"
              className="btn btn-outline-primary float-right p-2"
              onClick={() =>
                (window.location.href =
                  window.location.pathname + "/nuovo_report")
              }
            >
              <svg className="icon icon-primary">
                <use href={`${iconSprite}#it-plus-circle`} />
              </svg>{" "}
              <span className="align-middle">Nuovo Report</span>
            </button>
          </div>
        </div>

        <div className="container">
          <div className="row font-weight-bold py-2">
            <div className="col-9">Report</div>
            <div className="col-3 text-right"></div>
          </div>

          {reportsList && reportsList.length > 0 ? (
            reportsList.map((x) => (
              <div
                key={x.id}
                className="row align-items-center border-bottom py-2"
              >
                <div
                  className="col-9"
                  style={{ cursor: "pointer" }}
                  onClick={() => openReport(x.id)}
                >
                  <strong>{x.title}</strong>
                  <div>{x.description}</div>
                </div>

                <div className="col-3 text-right">
                  <button
                    className="btn btn-outline-primary p-1 mx-1"
                    title="Esegui"
                    onClick={() => openReport(x.id)}
                  >
                    <svg className="icon icon-primary">
                      <use href={`${iconSprite}#it-search`} />
                    </svg>
                  </button>
                  <button
                    className="btn btn-outline-primary p-1 mx-1"
                    title="Modifica"
                    onClick={() => editReport(x.id)}
                  >
                    <svg className="icon icon-primary">
                      <use href={`${iconSprite}#it-pencil`} />
                    </svg>
                  </button>
                  <button
                    className="btn btn-outline-danger p-1"
                    type="button"
                    title="Elimina"
                    onClick={() => {
                      toggleModal(!isOpen);
                      setRemovableReport(x.id);
                    }}
                  >
                    <svg className="icon icon-danger">
                      <use href={`${iconSprite}#it-delete`} />
                    </svg>
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-3">
              <b>Non sono presenti report</b>
            </div>
          )}

          {reportsListTemp && (
            <div className="p-2">
              <Pagination
                items={reportsListTemp}
                setCurrentItems={setReportsList}
                itemsPerPage={20}
              />
            </div>
          )}
        </div>
      </div>
      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header={"Rimozione Report"}
        body={"Confermi di voler rimuovere il report selezionato?"}
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => removeReportAPI()}
      ></ModalComponent>
      {!loading && <Loader></Loader>}
    </>
  );
}

export default ListReports;
